import type { ReactNode } from 'react';
import { CaraMark } from './CaraMark';
import { AlertIcon, EmptyBucketIcon, RefreshIcon } from './Icons';

interface SidebarStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  kind?: 'loading' | 'empty' | 'error' | 'brand';
  compact?: boolean;
}

export function SidebarState({
  title,
  description,
  action,
  kind = 'empty',
  compact = false
}: SidebarStateProps) {
  return (
    <section
      className={`sidebar-state sidebar-state--${kind}${compact ? ' sidebar-state--compact' : ''}`}
      role={kind === 'error' ? 'alert' : 'status'}
      aria-live="polite"
    >
      <div className="sidebar-state__icon" aria-hidden="true">
        {kind === 'loading' && <span className="loading-indicator" />}
        {kind === 'brand' && <CaraMark />}
        {kind === 'error' && <AlertIcon />}
        {kind === 'empty' && <EmptyBucketIcon />}
      </div>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
      {action && <div className="sidebar-state__action">{action}</div>}
    </section>
  );
}

export function RetryButton({
  children = 'Try again',
  onClick
}: {
  children?: ReactNode;
  onClick: () => void;
}) {
  return (
    <button type="button" className="button button--secondary button--pill" onClick={onClick}>
      <RefreshIcon />
      {children}
    </button>
  );
}

export function InlineError({
  message,
  onRetry,
  retryLabel = 'Try again'
}: {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  return (
    <div className="inline-error" role="alert">
      <AlertIcon />
      <span>{message}</span>
      {onRetry && (
        <button type="button" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  );
}
